import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
    CalendarDays,
    MapPin,
    Users,
    Sparkles,
    Handshake,
    Layers,
    ArrowRight,
    ArrowUpRight,
    Linkedin,
    Globe,
    Clock,
    Mic,
    Music,
    Instagram,
} from "lucide-react";
import SEO, { SITE_URL, breadcrumbSchema } from "@/components/seo/SEO";

const LUMA_URL = "https://luma.com/3qaneb4e";
const LOCATION_MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=36.0704889,-5.692933&query_place_id=ChIJl7XLkbCLDA0Rytfennvnngg";
const EVENT_DATE = new Date("2026-09-30T09:00:00+02:00");

const NAVY = "#082050";
const CORAL = "#1890C0";

const STATS = [
    { value: "50", label: "Plazas presenciales" },
    { value: "12", label: "Ponentes" },
    { value: "2", label: "Mesas de debate" },
    { value: "2", label: "Ejes de trabajo" },
    { value: "100%", label: "Conclusiones públicas" },
];

const EJES = [
    {
        icon: Handshake,
        kicker: "Eje 01",
        title: "Gobernanza institucional y plan estratégico turístico",
        desc: "Un plan estratégico compartido y una entidad de promoción turística con gobernanza clara, financiación estable y objetivos medibles.",
        points: [
            "Plan estratégico de destino",
            "Entidad de promoción turística",
            "Gobernanza y financiación",
            "Profesionalización del sector",
        ],
    },
    {
        icon: Layers,
        kicker: "Eje 02",
        title: "Estructuración, coherencia de experiencias y desestacionalización",
        desc: "Estructurar producto turístico sostenible y coherente que funcione fuera de temporada alta: naturaleza, patrimonio, gastronomía, viento y mar.",
        points: [
            "Diseño y coherencia de producto",
            "Sostenibilidad medible",
            "Calendario todo el año",
            "Relato común de destino",
        ],
    },
];

const PROGRAMA = [
    {
        time: "09:00 – 09:30",
        code: "Presentación",
        title: "Apertura e introducción",
        desc: "Bienvenida y presentación de la I Jornada Profesional & Networking de ASATTA.",
        speakers: [
            {
                ini: "PC",
                name: "Paola del Castillo",
                org: "Presidenta de ASATTA",
                focus: "Apertura e introducción de la jornada",
            },
        ],
    },
    {
        time: "09:30 – 10:30",
        code: "Mesa 1",
        title: "Institucional y coordinación",
        desc: "El hilo de esta mesa es pasar de diagnóstico → responsabilidad → compromiso, terminando con una acción concreta que cada institución pueda impulsar para Tarifa.",
        moderator: {
            name: "Carlos Fenoy Rico",
            org: "Presidente · Cámara de Comercio de la Bahía de Algeciras",
        },
        speakers: [
            {
                ini: "AG",
                name: "Ana Gómez Jiménez",
                org: "Técnica de Turismo · Ayuntamiento de Tarifa",
                focus: "Infraestructuras y necesidades para el turismo 365",
            },
            {
                ini: "MB",
                name: "María Bermúdez Calderón",
                org: "Gerente · Patronato Municipal de Turismo de Conil",
                focus: "Aprendizajes sobre desestacionalización",
            },
            {
                ini: "CJ",
                name: "Carlos Jordán",
                org: "Coordinador-Técnico de Turismo · Ayuntamiento de San Roque",
                focus: "Transformación de recursos y ejecución",
            },
            {
                ini: "MC",
                name: "Miriam Carrión",
                org: "Directora · Patronato Provincial de Turismo de la Diputación de Cádiz",
                focus: "Estrategia provincial, posicionamiento de Tarifa y apoyo al destino",
                logo: "/assets/jornada/colaboradores/diputacion-cadiz-patronato.png",
            },
        ],
    },
    {
        time: "10:30 – 11:30",
        code: "Mesa 2 · Parte I",
        title: "De los recursos al destino: experiencias y talento local",
        desc: "Empresas y profesionales que ya diseñan producto turístico sostenible y desestacionalizado en la comarca.",
        moderator: {
            name: "Maybet Ordoñez",
            org: "Responsable de Marketing · ASATTA",
        },
        speakers: [
            {
                ini: "LD",
                name: "Léonie Duret",
                org: "Fundadora de CYMBAS Wellness Studio",
                focus: "Wellness y naturaleza",
            },
            {
                ini: "NQ",
                name: "Natalia Queiruga Galeote",
                org: "Creadora de Tarifa Beer",
                focus: "Producto local e identidad de marca",
                web: "https://tarifabeer.com/",
            },
            {
                ini: "AL",
                name: "Alejandro Gainza",
                org: "Ciclista profesional tarifeño",
                focus: "Turismo deportivo sostenible",
            },
            {
                ini: "SP",
                name: "Sergio Pérez",
                org: "Swim en el Mar · escuela de natación en aguas abiertas",
                focus: "Nadador de aguas abiertas, Técnico en Natación y Socorrista: experiencias y travesías a nado en el Parque Natural del Estrecho, del mar como límite al mar como aliado",
                web: "https://swimenelmar.es/",
            },
        ],
    },
    {
        time: "11:30 – 12:30",
        code: "Mesa 2 · Parte II",
        title: "De los recursos al destino: estrategia y gobernanza",
        desc: "Especialistas en alojamiento, estrategia y comunicación para convertir las ideas en una hoja de ruta ejecutable.",
        moderator: {
            name: "Jeanne Wambergue",
            org: "Vicepresidenta · ASATTA",
        },
        speakers: [
            {
                ini: "AB",
                name: "Antonello Buono",
                org: "Hotelero · valorización de propiedades con encanto",
                focus: "El alojamiento como conector del territorio",
            },
            {
                ini: "IL",
                name: "Iosu López — Mochileros TV",
                org: "Viajes, videoperiodismo y marketing turístico",
                focus: "Comunicación y mirada del viajero",
            },
            {
                ini: "IS",
                name: "Isabel Sánchez Tejado",
                org: "Especialista en Turismo Generativo",
                focus: "Gobernanza compartida y hoja de ruta",
                linkedin: "https://www.linkedin.com/in/isabelsancheztejado/",
            },
            {
                ini: "SL",
                name: "Salvador Miguel León",
                org: "Volare Sub · turismo activo marino en el Estrecho",
                focus: "Submarinismo y cooperación marina",
                web: "https://www.volaresub.com/",
            },
        ],
    },
    {
        time: "12:30 – 13:00",
        code: "Cierre",
        title: "Cierre y conclusiones",
        desc: "Bloque final de conclusiones oficiales a cargo de la Junta Directiva de ASATTA.",
        speakers: [
            {
                ini: "JD",
                name: "Junta Directiva de ASATTA",
                org: "Conclusiones oficiales",
                focus: "Compromisos y hoja de ruta de Tarifa tras el encuentro",
            },
        ],
    },
    {
        time: "13:00",
        code: "Networking",
        title: "Cocktail Hour & Networking",
        desc: "Momento social para conectar con todos los participantes, con una selección de Tarifa Beer.",
        musician: {
            name: "Alberto Beltrán",
            org: "Guitarrista · actuación acústica",
        },
        speakers: [],
    },
];

const COLABORADORES = [
    { name: "Excmo. Ayuntamiento de Tarifa", img: "/assets/jornada/colaboradores/ayuntamiento-tarifa.png" },
    { name: "Turismo de Cádiz", img: "/assets/jornada/colaboradores/turismo-cadiz.png" },
    { name: "Cámara de Comercio de la Bahía de Algeciras", img: "/assets/jornada/colaboradores/camara-comercio.png" },
    { name: "Diputación de Cádiz · Patronato Provincial de Turismo", img: "/assets/jornada/colaboradores/diputacion-cadiz-patronato.png" },
    { name: "Mochileros TV", img: "/assets/jornada/colaboradores/mochileros-tv.png" },
    { name: "Ayuntamiento de San Roque", img: "/assets/jornada/colaboradores/ayuntamiento-san-roque.png" },
    { name: "Patronato Municipal de Turismo de Conil", img: "/assets/jornada/colaboradores/turismo-conil.png" },
    { name: "Swim en el Mar", img: "/assets/jornada/colaboradores/swim-en-el-mar.png" },
    { name: "Love Moments Photography", img: "/assets/jornada/colaboradores/love-moments-photography.png" },
];

const RAZONES = [
    {
        title: "Influye en el plan del destino",
        desc: "Tus aportaciones se recogen en el documento de conclusiones que se traslada a las administraciones.",
    },
    {
        title: "Networking con criterio",
        desc: "Empresas, instituciones y profesionales del turismo de la comarca en una misma sala, con espacios de encuentro dirigidos.",
    },
    {
        title: "Casos reales, no teoría",
        desc: "Experiencias de destinos que ya han desestacionalizado con producto estructurado y datos sobre la mesa.",
    },
    {
        title: "Herramientas aplicables",
        desc: "Te llevas plantillas de diseño de experiencias y una guía de indicadores de sostenibilidad.",
    },
];

/* ---------- Animación de aparición al hacer scroll ---------- */
const Reveal = ({ children, delay = 0, className = "" }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    obs.disconnect();
                }
            },
            { threshold: 0.15 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);
    return (
        <div
            ref={ref}
            style={{ transitionDelay: `${delay}ms` }}
            className={`${className} transition-[opacity,transform] duration-700 ease-out ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
        >
            {children}
        </div>
    );
};

/* ---------- Cuenta atrás ---------- */
const useCountdown = () => {
    const calc = () => {
        const diff = Math.max(0, EVENT_DATE.getTime() - Date.now());
        return {
            days: Math.floor(diff / 86400000),
            hours: Math.floor(diff / 3600000) % 24,
            minutes: Math.floor(diff / 60000) % 60,
            seconds: Math.floor(diff / 1000) % 60,
        };
    };
    const [t, setT] = useState(calc);
    useEffect(() => {
        const id = setInterval(() => setT(calc()), 1000);
        return () => clearInterval(id);
    }, []);
    return t;
};

const Countdown = () => {
    const t = useCountdown();
    const cells = [
        { v: t.days, l: "Días" },
        { v: t.hours, l: "Horas" },
        { v: t.minutes, l: "Min" },
        { v: t.seconds, l: "Seg" },
    ];
    return (
        <div data-testid="jornada-countdown" className="flex gap-2 sm:gap-3">
            {cells.map((c) => (
                <div
                    key={c.l}
                    className="min-w-[68px] sm:min-w-[84px] border border-white/25 bg-white/10 backdrop-blur-md px-3 py-2 text-center"
                >
                    <div className="text-2xl sm:text-3xl font-semibold leading-none tabular-nums text-white">
                        {String(c.v).padStart(2, "0")}
                    </div>
                    <div className="mt-1 text-[10px] uppercase tracking-[0.18em] text-white/70">
                        {c.l}
                    </div>
                </div>
            ))}
        </div>
    );
};

/* ---------- Tarjeta de ponente (sin retrato) ---------- */
const SpeakerRow = ({ speaker, delay }) => (
    <Reveal delay={delay}>
        <div
            data-testid={`jornada-speaker-${speaker.ini.toLowerCase()}`}
            className="border border-[#E2E4E9] bg-white p-4 sm:p-5 hover:border-[#082050] transition-colors"
        >
            <span className="flex items-start justify-between gap-3">
                <span>
                    <span className="block text-sm font-semibold text-[#082050]">
                        {speaker.name}
                    </span>
                    <span className="block text-sm text-[#4A5568]">
                        {speaker.org}
                    </span>
                </span>
                {speaker.logo && (
                    <img
                        src={speaker.logo}
                        alt=""
                        aria-hidden="true"
                        loading="lazy"
                        className="h-9 w-auto max-w-[110px] object-contain shrink-0"
                    />
                )}
            </span>
            <span
                className="mt-2 block border-l-2 pl-3 text-xs leading-relaxed text-[#4A5568]"
                style={{ borderColor: CORAL }}
            >
                {speaker.focus}
            </span>
            {(speaker.linkedin || speaker.web) && (
                <span className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1">
                    {speaker.linkedin && (
                        <a
                            href={speaker.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`jornada-speaker-linkedin-${speaker.ini.toLowerCase()}`}
                            className="inline-flex items-center gap-1.5 text-xs font-medium text-[#082050]/60 hover:text-[#082050] transition-colors"
                        >
                            <Linkedin size={13} />
                            LinkedIn
                        </a>
                    )}
                    {speaker.web && (
                        <a
                            href={speaker.web}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`jornada-speaker-web-${speaker.ini.toLowerCase()}`}
                            className="inline-flex items-center gap-1.5 text-xs font-medium text-[#082050]/60 hover:text-[#082050] transition-colors"
                        >
                            <Globe size={13} />
                            {speaker.web
                                .replace(/^https?:\/\/(www\.)?/, "")
                                .replace(/\/$/, "")}
                        </a>
                    )}
                </span>
            )}
            {speaker.note && (
                <span className="mt-2 block text-[11px] italic leading-relaxed text-[#718096]">
                    {speaker.note}
                </span>
            )}
        </div>
    </Reveal>
);

/* ---------- Tarjeta destacada de rol (moderador / música) ---------- */
const RoleCard = ({ label, name, org, icon: Icon, testid }) => (
    <div
        data-testid={testid}
        className="mt-4 inline-flex items-center gap-3 border border-[#082050]/20 bg-white px-4 py-3 shadow-[0_2px_12px_rgba(8,32,80,0.06)]"
    >
        <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white"
            style={{ backgroundColor: CORAL }}
        >
            <Icon size={16} />
        </span>
        <span>
            <span className="block text-[10px] uppercase tracking-[0.18em] text-[#718096]">
                {label}
            </span>
            <span className="block text-sm font-semibold text-[#082050]">
                {name}{" "}
                <span className="font-normal text-[#718096]">· {org}</span>
            </span>
        </span>
    </div>
);

export default function JornadaNetworking() {
    return (
        <div data-testid="jornada-networking-page" className="bg-white">
            <SEO
                title="Encuentro ASATTA Tarifa | Turismo, experiencias e innovación"
                description="Encuentro profesional de turismo e innovación en Tarifa: profesionalización del sector, colaboración público-privada y experiencias sostenibles y desestacionalizadas. 30 de septiembre de 2026 · Resort Las Dunas."
                path="/eventos/jornada-networking"
                image={`${SITE_URL}/assets/jornada/hero-tarifa.jpg`}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": "Encuentro ASATTA Tarifa · Experiencias, estrategia y valor",
                        "description":
                            "Un día de trabajo entre sector e instituciones para profesionalizar el turismo de la comarca, impulsar un plan estratégico compartido y estructurar experiencias sostenibles fuera de temporada alta.",
                        "startDate": "2026-09-30T09:00:00+02:00",
                        "endDate": "2026-09-30T14:00:00+02:00",
                        "eventStatus": "https://schema.org/EventScheduled",
                        "eventAttendanceMode":
                            "https://schema.org/OfflineEventAttendanceMode",
                        "location": {
                            "@type": "Place",
                            "name": "Resort Las Dunas",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "C/ Los Algarbes s/n",
                                "postalCode": "11380",
                                "addressLocality": "Valdevaqueros, Tarifa",
                                "addressRegion": "Cádiz",
                                "addressCountry": "ES",
                            },
                        },
                        "organizer": {
                            "@type": "Organization",
                            "name": "ASATTA · Asociación de Alojamientos Turísticos de Tarifa",
                            "url": "https://asatta.org",
                        },
                        "offers": {
                            "@type": "Offer",
                            "url": LUMA_URL,
                            "availability": "https://schema.org/InStock",
                            "price": "0",
                            "priceCurrency": "EUR",
                        },
                        "performer": [
                            { "@type": "Person", "name": "Paola del Castillo" },
                            { "@type": "Person", "name": "Ana Gómez Jiménez" },
                            { "@type": "Person", "name": "María Bermúdez Calderón" },
                            { "@type": "Person", "name": "Carlos Jordán" },
                            { "@type": "Person", "name": "Miriam Carrión" },
                            { "@type": "Person", "name": "Carlos Fenoy Rico" },
                            { "@type": "Person", "name": "Maybet Ordoñez" },
                            { "@type": "Person", "name": "Jeanne Wambergue" },
                            { "@type": "Person", "name": "Alejandro Gainza" },
                            { "@type": "Person", "name": "Léonie Duret" },
                            { "@type": "Person", "name": "Isabel Sánchez Tejado" },
                            { "@type": "Person", "name": "Sergio Pérez" },
                            { "@type": "Person", "name": "Antonello Buono" },
                            { "@type": "Person", "name": "Iosu López" },
                            { "@type": "Person", "name": "Salvador Miguel León" },
                            { "@type": "Person", "name": "Natalia Queiruga Galeote" },
                            { "@type": "Person", "name": "Alberto Beltrán" },
                        ],
                    },
                    breadcrumbSchema([
                        { name: "Inicio", path: "/" },
                        { name: "Eventos", path: "/eventos" },
                        {
                            name: "Encuentro ASATTA Tarifa",
                            path: "/eventos/jornada-networking",
                        },
                    ]),
                ]}
            />

            {/* ============ HERO ============ */}
            <section className="relative min-h-[100svh] overflow-hidden flex flex-col">
                <img
                    src="/assets/jornada/hero-tarifa.jpg"
                    alt="Vista aérea de Tarifa al atardecer, con la playa y el Estrecho de Gibraltar"
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(8,32,80,0.82) 0%, rgba(8,32,80,0.45) 45%, rgba(8,32,80,0.88) 100%)",
                    }}
                />
                <div className="relative mx-auto flex min-h-[100svh] w-full max-w-6xl flex-col justify-end px-5 pb-10 sm:pb-16 pt-24 sm:pt-32">
                    {/* Breadcrumb */}
                    <nav
                        aria-label="Breadcrumb"
                        className="absolute top-24 left-5 text-xs text-white/60"
                    >
                        <ol className="flex items-center gap-2 flex-wrap">
                            <li>
                                <Link to="/" className="hover:text-white">
                                    Inicio
                                </Link>
                            </li>
                            <li aria-hidden="true">/</li>
                            <li>
                                <Link to="/eventos" className="hover:text-white">
                                    Eventos
                                </Link>
                            </li>
                            <li aria-hidden="true">/</li>
                            <li className="text-white">Encuentro ASATTA Tarifa</li>
                        </ol>
                    </nav>

                    <div className="max-w-3xl">
                        <Reveal>
                            <p className="mb-5 inline-flex items-center gap-2 border border-white/30 px-3 py-1.5 text-[11px] uppercase tracking-[0.22em] text-white/85">
                                <Sparkles size={14} strokeWidth={1.75} />
                                Encuentro profesional · Turismo e innovación
                            </p>
                        </Reveal>
                        <Reveal delay={100}>
                            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-semibold leading-[1.05] text-white tracking-tight">
                                Experiencias, estrategia y valor: una ruta común
                                para el destino Tarifa
                            </h1>
                        </Reveal>
                        <Reveal delay={200}>
                            <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-white/85">
                                Un día de trabajo entre sector e instituciones
                                para profesionalizar el turismo de la comarca,
                                impulsar un plan estratégico compartido y
                                estructurar experiencias sostenibles fuera de
                                temporada alta.
                            </p>
                        </Reveal>
                        <Reveal delay={300}>
                            <div className="mt-5 sm:mt-8 flex flex-wrap items-center gap-x-6 gap-y-2.5 sm:gap-y-3 text-sm text-white/80">
                                <span className="inline-flex items-center gap-2">
                                    <CalendarDays size={16} />
                                    30 de septiembre de 2026
                                </span>
                                <span className="inline-flex items-center gap-2">
                                    <MapPin size={16} />
                                    Resort Las Dunas, Tarifa
                                </span>
                                <span className="inline-flex items-center gap-2">
                                    <Users size={16} />
                                    Aforo limitado a 50 plazas
                                </span>
                            </div>
                        </Reveal>
                        <Reveal delay={400}>
                            <div className="mt-6 sm:mt-9 flex flex-col gap-5 sm:gap-6 sm:flex-row sm:items-center">
                                <Countdown />
                                <div className="flex flex-wrap items-center gap-3">
                                    <a
                                        href={LUMA_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-jornada-register"
                                        className="group inline-flex w-fit items-center gap-2 px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
                                        style={{ backgroundColor: CORAL }}
                                    >
                                        Registro gratuito
                                        <ArrowRight
                                            size={16}
                                            className="transition-transform group-hover:translate-x-1"
                                        />
                                    </a>
                                    <a
                                        href={LOCATION_MAPS_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-jornada-map"
                                        className="inline-flex w-fit items-center gap-2 border border-white/40 text-white px-6 py-3.5 text-sm font-medium hover:bg-white/10 transition-colors"
                                    >
                                        Cómo llegar
                                        <ArrowUpRight size={14} />
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* ============ CIFRAS ============ */}
            <section className="border-b border-[#E2E4E9] bg-white">
                <div
                    data-testid="jornada-stats"
                    className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-5 py-12 sm:grid-cols-3 md:grid-cols-5"
                >
                    {STATS.map((s, i) => (
                        <Reveal
                            key={s.label}
                            delay={i * 80}
                            className={
                                i === STATS.length - 1
                                    ? "col-span-2 text-center sm:col-span-1 sm:text-left"
                                    : ""
                            }
                        >
                            <div className="text-3xl sm:text-4xl font-semibold text-[#082050] tabular-nums">
                                {s.value}
                            </div>
                            <div className="mt-1 text-xs uppercase tracking-[0.16em] text-[#718096]">
                                {s.label}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>

            {/* ============ MANIFIESTO ============ */}
            <section
                data-testid="jornada-manifiesto"
                className="relative overflow-hidden bg-[#F8F9FA]"
            >
                <img
                    src="/assets/jornada/texture-wind.jpg"
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-45"
                />
                <div className="relative mx-auto max-w-4xl px-5 py-24 sm:py-32">
                    <Reveal>
                        <p className="text-[11px] uppercase tracking-[0.24em] text-[#718096]">
                            Manifiesto
                        </p>
                        <h2 className="mt-4 text-3xl sm:text-5xl font-semibold leading-tight text-[#082050] tracking-tight">
                            Turismo de experiencias y valoración del destino
                        </h2>
                        <div
                            className="mt-6 h-px w-24"
                            style={{ backgroundColor: CORAL }}
                        />
                    </Reveal>
                    <Reveal delay={150}>
                        <div className="mt-8 space-y-6 text-lg leading-relaxed text-[#082050]/85">
                            <p>
                                Tarifa no compite por volumen. Compite por
                                singularidad: dos mares, viento, patrimonio,
                                parque natural y una comunidad que vive del
                                turismo todo el año. Defender eso exige dejar de
                                vender noches sueltas y empezar a construir
                                experiencias con relato, calidad y precio justo.
                            </p>
                            <p>
                                Creemos en un destino que se valora a sí mismo:
                                que forma a sus profesionales, que mide su
                                impacto, que reparte los beneficios en el
                                territorio y que reduce la presión de los meses
                                punta activando el resto del calendario.
                            </p>
                            <p className="text-xl sm:text-2xl font-semibold text-[#082050]">
                                «Valorar el destino es la primera política
                                turística. El resto son consecuencias.»
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>

            {/* ============ EJES ============ */}
            <section className="bg-white">
                <div className="mx-auto max-w-6xl px-5 py-24 sm:py-32">
                    <Reveal>
                        <div className="max-w-2xl">
                            <p className="text-[11px] uppercase tracking-[0.24em] text-[#718096]">
                                Programa de trabajo
                            </p>
                            <h2 className="mt-4 text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                                Dos ejes, una hoja de ruta
                            </h2>
                        </div>
                    </Reveal>
                    <div className="mt-14 grid gap-6 md:grid-cols-2">
                        {EJES.map((eje, i) => (
                            <Reveal key={eje.kicker} delay={i * 150} className="h-full">
                                <div
                                    data-testid={`jornada-eje-${i + 1}`}
                                    className="group flex h-full flex-col border border-[#E2E4E9] bg-white p-8 transition-colors hover:border-[#1890C0]"
                                >
                                    <eje.icon
                                        size={28}
                                        strokeWidth={1.75}
                                        style={{ color: CORAL }}
                                    />
                                    <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#718096]">
                                        {eje.kicker}
                                    </p>
                                    <h3 className="mt-2 text-2xl font-semibold text-[#082050] tracking-tight">
                                        {eje.title}
                                    </h3>
                                    <p className="mt-4 flex-1 text-sm leading-relaxed text-[#4A5568]">
                                        {eje.desc}
                                    </p>
                                    <ul className="mt-6 space-y-2 border-t border-[#E2E4E9] pt-5">
                                        {eje.points.map((p) => (
                                            <li
                                                key={p}
                                                className="flex items-start gap-2 text-sm text-[#082050]/80"
                                            >
                                                <span
                                                    className="mt-2 h-1 w-1 shrink-0 rounded-full"
                                                    style={{ backgroundColor: CORAL }}
                                                />
                                                {p}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* ============ PONENTES / PROGRAMA ============ */}
            <section id="ponentes" className="bg-[#F8F9FA] border-y border-[#E2E4E9]">
                <div className="mx-auto max-w-6xl px-5 py-24 sm:py-32">
                    <Reveal>
                        <div className="max-w-2xl">
                            <p className="text-[11px] uppercase tracking-[0.24em] text-[#718096]">
                                Ponentes y programa
                            </p>
                            <h2 className="mt-4 text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                                El programa de la jornada
                            </h2>
                            <p
                                data-testid="mesa-experiencias-chain"
                                className="mt-5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] uppercase tracking-[0.18em] font-semibold text-[#082050]"
                            >
                                Recurso
                                <span style={{ color: CORAL }}>→</span>
                                Experiencia
                                <span style={{ color: CORAL }}>→</span>
                                Producto
                                <span style={{ color: CORAL }}>→</span>
                                Destino
                            </p>
                            <p className="mt-2 text-xs leading-relaxed text-[#718096]">
                                Alojamiento, deporte, bienestar, cultura y
                                tejido local conectados para desestacionalizar
                                Tarifa.
                            </p>
                        </div>
                    </Reveal>

                    {/* Línea de tiempo del programa */}
                    <div className="mt-16 relative">
                        <div
                            className="absolute left-[7px] top-2 bottom-2 w-px bg-[#082050]/15"
                            aria-hidden="true"
                        />
                        <div className="space-y-16">
                            {PROGRAMA.map((bloque, bi) => (
                                <div
                                    key={bloque.code}
                                    data-testid={`jornada-bloque-${bi + 1}`}
                                    className="relative pl-10 sm:pl-14"
                                >
                                    <span
                                        className="absolute left-0 top-2 h-[15px] w-[15px] rounded-full border-[3px] bg-[#F8F9FA]"
                                        style={{ borderColor: CORAL }}
                                        aria-hidden="true"
                                    />
                                    <Reveal>
                                        <div className="flex flex-wrap items-center gap-3">
                                            <span className="inline-flex items-center gap-2 border border-[#082050]/20 bg-white px-3 py-1.5 text-xs font-semibold tracking-widest text-[#082050] tabular-nums">
                                                <Clock size={13} />
                                                {bloque.time}
                                            </span>
                                            <span
                                                className="text-[11px] uppercase tracking-[0.22em] font-semibold"
                                                style={{ color: CORAL }}
                                            >
                                                {bloque.code}
                                            </span>
                                        </div>
                                        <h3 className="mt-4 text-2xl sm:text-3xl font-semibold text-[#082050] tracking-tight">
                                            {bloque.title}
                                        </h3>
                                        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-[#4A5568]">
                                            {bloque.desc}
                                        </p>
                                        {bloque.moderator && (
                                            <RoleCard
                                                testid={`jornada-moderador-${bi + 1}`}
                                                label="Modera"
                                                name={bloque.moderator.name}
                                                org={bloque.moderator.org}
                                                icon={Mic}
                                            />
                                        )}
                                        {bloque.musician && (
                                            <RoleCard
                                                testid={`jornada-musico-${bi + 1}`}
                                                label="Actuación acústica"
                                                name={bloque.musician.name}
                                                org={bloque.musician.org}
                                                icon={Music}
                                            />
                                        )}
                                    </Reveal>
                                    {bloque.speakers.length > 0 && (
                                        <div
                                            className={`mt-8 grid gap-3 sm:grid-cols-2 ${
                                                bloque.speakers.length === 3
                                                    ? "lg:grid-cols-3"
                                                    : ""
                                            }`}
                                        >
                                            {bloque.speakers.map((s, i) => (
                                                <SpeakerRow
                                                    key={s.ini}
                                                    speaker={s}
                                                    delay={i * 80}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ============ RAZONES ============ */}
            <section className="text-white" style={{ backgroundColor: NAVY }}>
                <div className="mx-auto max-w-6xl px-5 py-24 sm:py-32">
                    <Reveal>
                        <div className="max-w-2xl">
                            <p className="text-[11px] uppercase tracking-[0.24em] text-white/60">
                                Razones para asistir
                            </p>
                            <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                                Sales con decisiones, no con apuntes
                            </h2>
                        </div>
                    </Reveal>
                    <div className="mt-14 grid gap-px overflow-hidden border border-white/15 bg-white/15 sm:grid-cols-2">
                        {RAZONES.map((r, i) => (
                            <Reveal key={r.title} delay={i * 100}>
                                <div
                                    data-testid={`jornada-reason-${i}`}
                                    className="h-full p-8"
                                    style={{ backgroundColor: NAVY }}
                                >
                                    <span
                                        className="text-sm font-semibold"
                                        style={{ color: CORAL }}
                                    >
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <h3 className="mt-3 text-xl font-semibold text-white tracking-tight">
                                        {r.title}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-white/70">
                                        {r.desc}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* ============ COMUNIDAD + REGISTRO ============ */}
            <section className="bg-white">
                <div className="mx-auto grid max-w-6xl gap-14 px-5 py-24 sm:py-32 md:grid-cols-2">
                    <Reveal>
                        <div data-testid="jornada-community">
                            <p className="text-[11px] uppercase tracking-[0.24em] text-[#718096]">
                                Recursos y comunidad
                            </p>
                            <h2 className="mt-4 text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                                El encuentro no termina en Tarifa
                            </h2>
                            <p className="mt-5 text-base leading-relaxed text-[#4A5568]">
                                ASATTA mantiene abierto el trabajo entre
                                encuentros: documentación, grupos de trabajo por
                                eje y seguimiento del plan estratégico junto a
                                las administraciones.
                            </p>
                            <p className="mt-6 text-sm text-[#718096]">
                                Los materiales del encuentro (dossier, guías y
                                conclusiones) se publicarán próximamente.
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={150}>
                        <div
                            data-testid="jornada-cta-card"
                            className="border border-[#E2E4E9] bg-[#F8F9FA] p-8 sm:p-10"
                        >
                            <h3 className="text-2xl font-semibold text-[#082050] tracking-tight">
                                Reserva tu plaza
                            </h3>
                            <p className="mt-2 text-sm text-[#4A5568]">
                                Registro gratuito y aforo limitado a 50 plazas.
                                Recibirás confirmación por correo.
                            </p>
                            <div className="mt-8 space-y-3 text-sm text-[#082050]/80">
                                <div className="flex items-center gap-3">
                                    <CalendarDays
                                        size={16}
                                        className="shrink-0 text-[#718096]"
                                    />
                                    30 de septiembre de 2026
                                </div>
                                <div className="flex items-center gap-3">
                                    <MapPin
                                        size={16}
                                        className="shrink-0 text-[#718096]"
                                    />
                                    Resort Las Dunas, Tarifa
                                </div>
                                <div className="flex items-center gap-3">
                                    <Users
                                        size={16}
                                        className="shrink-0 text-[#718096]"
                                    />
                                    Aforo limitado a 50 plazas
                                </div>
                            </div>
                            <a
                                href={LUMA_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="btn-jornada-register-final"
                                className="mt-8 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
                                style={{ backgroundColor: CORAL }}
                            >
                                Confirmar registro
                                <ArrowUpRight size={16} />
                            </a>
                            <p className="mt-3 text-[11px] text-[#718096] leading-relaxed text-center">
                                La inscripción se gestiona a través de Luma.
                            </p>
                            <div className="mt-6 pt-6 border-t border-[#E2E4E9] text-center">
                                <Link
                                    to="/eventos"
                                    data-testid="btn-jornada-back"
                                    className="inline-flex items-center gap-2 text-sm text-[#082050] hover:gap-3 transition-all"
                                >
                                    Ver todos los eventos
                                    <ArrowRight size={14} />
                                </Link>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>

            {/* ============ PATROCINADOR + COLABORADORES ============ */}
            <section className="bg-white border-t border-[#E2E4E9]">
                <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
                    {/* Patrocinador + Fotografía oficial */}
                    <Reveal>
                        <p
                            data-testid="jornada-sponsor"
                            className="text-center text-[11px] uppercase tracking-[0.24em] text-[#718096]"
                        >
                            Con el patrocinio de
                        </p>
                    </Reveal>
                    <div className="mt-10 grid gap-6 md:grid-cols-2 max-w-4xl mx-auto">
                        {/* Tarifa Beer — patrocinador oficial */}
                        <Reveal className="h-full">
                            <div
                                data-testid="jornada-sponsor-tarifa-beer"
                                className="relative h-full border border-[#E2E4E9] bg-white p-8 sm:p-10 flex flex-col items-center text-center hover:border-[#1890C0] transition-colors"
                            >
                                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#082050] text-white text-[10px] uppercase tracking-[0.18em] px-3 py-1 whitespace-nowrap">
                                    Patrocinador oficial
                                </span>
                                <img
                                    src="/assets/jornada/colaboradores/tarifa-beer.png"
                                    alt="Logo de Tarifa Beer, patrocinador oficial del encuentro"
                                    className="h-24 sm:h-28 w-auto object-contain transition-transform duration-500 hover:scale-105"
                                />
                                <p className="mt-5 text-sm leading-relaxed text-[#4A5568]">
                                    Producto local auténtico de Tarifa. La
                                    cerveza de nuestro Cocktail Hour.
                                </p>
                                <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                                    <a
                                        href="https://tarifabeer.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-tarifa-beer-web"
                                        className="inline-flex items-center gap-2 bg-[#082050] text-white px-5 py-2.5 text-xs font-semibold hover:bg-[#082050]/90 transition-transform hover:-translate-y-0.5"
                                    >
                                        Conoce sus cervezas
                                        <ArrowUpRight size={13} />
                                    </a>
                                    <a
                                        href="https://instagram.com/tarifabeer"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-tarifa-beer-instagram"
                                        className="inline-flex items-center gap-1.5 border border-[#E2E4E9] text-[#082050] px-4 py-2.5 text-xs font-medium hover:border-[#082050] transition-colors"
                                    >
                                        <Instagram size={13} />
                                        @tarifabeer
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                        {/* Love Moments Photography — fotografía oficial */}
                        <Reveal delay={120} className="h-full">
                            <div
                                data-testid="jornada-media-partner"
                                className="relative h-full border border-[#E2E4E9] bg-white p-8 sm:p-10 flex flex-col items-center text-center hover:border-[#1890C0] transition-colors"
                            >
                                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white border border-[#082050]/25 text-[#082050] text-[10px] uppercase tracking-[0.18em] px-3 py-1 whitespace-nowrap">
                                    Fotografía oficial
                                </span>
                                <img
                                    src="/assets/jornada/colaboradores/love-moments-photography.png"
                                    alt="Logo de Love Moments Photography"
                                    loading="lazy"
                                    className="h-16 sm:h-20 w-auto object-contain transition-transform duration-500 hover:scale-105"
                                />
                                <p className="mt-5 text-sm leading-relaxed text-[#4A5568]">
                                    Nuestros fotógrafos oficiales. Especialistas
                                    en capturar la esencia de Tarifa.
                                </p>
                                <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                                    <a
                                        href="https://www.lovemomentsphotography.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-lovemoments-web"
                                        className="inline-flex items-center gap-2 bg-[#082050] text-white px-5 py-2.5 text-xs font-semibold hover:bg-[#082050]/90 transition-transform hover:-translate-y-0.5"
                                    >
                                        Visita su Portfolio
                                        <ArrowUpRight size={13} />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/lovemomentsphoto/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="btn-lovemoments-instagram"
                                        className="inline-flex items-center gap-1.5 border border-[#E2E4E9] text-[#082050] px-4 py-2.5 text-xs font-medium hover:border-[#082050] transition-colors"
                                    >
                                        <Instagram size={13} />
                                        @lovemomentsphoto
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                    </div>

                    {/* Colaboradores y participantes */}
                    <div className="mt-20 sm:mt-24">
                        <Reveal>
                            <div className="text-center">
                                <h2 className="text-2xl sm:text-3xl font-semibold text-[#082050] tracking-tight">
                                    Colaboradores y participantes
                                </h2>
                            </div>
                        </Reveal>
                        <Reveal delay={120}>
                            <div
                                data-testid="jornada-colaboradores"
                                className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-12 items-center"
                            >
                                {COLABORADORES.map((c, i) => (
                                    <div
                                        key={c.name}
                                        data-testid={`jornada-colaborador-${i}`}
                                        title={c.name}
                                        className="flex items-center justify-center h-20 sm:h-24"
                                    >
                                        <img
                                            src={c.img}
                                            alt={`Logo de ${c.name}`}
                                            loading="lazy"
                                            className="max-h-16 sm:max-h-20 w-auto max-w-full object-contain transition-transform duration-500 hover:scale-110"
                                        />
                                    </div>
                                ))}
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>
        </div>
    );
}
